import * as React from 'react'
import { PasswordField } from '@doordash/component-fields'
import { OnboardingComponentProps } from '.'

export const PasswordComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ ...props }) => {
    return <PasswordField {...props} />
  }
)
